var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "inner",
    title: "Inner Element",
    description: "An element or array of elements containing their own 'n' keys. Each must be a valid component.",
    type: "field",
    use: {
        namespace: "ua.inner"
    },
    fields: {
        namespaces: {
            title: "Allowed Namespaces",
            type: "list",
            of: "string"
        }
    },
    tests: {
        validSingle: {
            must: true,
            run: function () {
                return validate({}, { n: "text", content: "Hello" });
            }
        },
        validArray: {
            must: true,
            run: function () {
                return validate({}, [{ n: "text", content: "Hi" }, { n: "image", src: "/logo.png" }]);
            }
        },
        invalidNoN: {
            throw: "fields.inner.missingN",
            run: function () {
                return validate({}, { content: "Hello" });
            }
        }
    },
    errors: {
        noNamespace: {
            title: "Missing Namespace",
            description: "An object provided has no namespace."
        },
        invalidChildren: {
            title: "Invalid Children",
            description: "The provided value is not a valid inner. It must be an object with a namespace, a string, or an array."
        },
        invalidChildrenForAllowedNamespaceFlag: {
            title: "Invalid Children for Allowed Namespace",
            description: "The provided value is not a valid inner. It must be an object with a 'namespace' property or an array of obejcts with a namespace.",
            template: "Invalid inner item: '${item}' allowed namespaces are: ${allowed}"
        },
        notAllowed: {
            title: "Namespace Not Allowed",
            description: "The namespace provided is not allowed in this context.",
            template: "Namespace '${namespace}' is not allowed. Allowed namespaces are: ${allowed}"
        }
    }
});

function validate(spec, value) {

    var required = spec.required || false;

    if ("namespaces" in spec) {
        //is it an object or array?
        if (Array.isArray(value)) {
            value.forEach(item => validateItem(spec, item));
        } else if (typeof value === "object" && value !== null) {
            validateItem(spec, value);
        } else {
            _.errors.noNamespace.throw({ item: JSON.stringify(value) });
        }
    } else {
        //it can be a string, an object, or an array
        if (typeof value === "string") {
            if (value.trim() === "") {
                _.errors.invalidChildren.throw({ item: JSON.stringify(value) });
            }

            //is required property set to true?
            if (required) {
                if (value.trim() === "") {
                    _.errors.invalidChildren.throw({ item: JSON.stringify(value) });
                }
            }

        } else if (Array.isArray(value)) {

            if (required) {
                if (value.length === 0) {
                    _.errors.invalidChildren.throw({ item: JSON.stringify(value) });
                }
            }

        } else if (typeof value === "object") {
            //is their a "namespace" property?
            if (value === null || !value.hasOwnProperty("namespace")) {
                _.errors.invalidChildren.throw({ item: JSON.stringify(value) });
            }
        } else {
            _.errors.invalidChildren.throw({ item: JSON.stringify(value) });
        }
    }
} module.exports.validate = validate;


function validateItem(spec, item) {
    if (typeof item !== "object" || item === null) {
        _.errors.invalidChildrenForAllowedNamespaceFlag.throw({ item: JSON.stringify(item) });
    }
    if (!item.hasOwnProperty("namespace")) {
        _.errors.noNamespace.throw({ item: JSON.stringify(item) });
    }
    if (spec.fields && spec.fields.namespaces && !spec.fields.namespaces.includes(item.namespace)) {
        _.errors.notAllowed.throw({
            namespace: item.namespace,
            allowed: spec.fields.namespaces.join(", ")
        });
    }
}